module.exports = __webpack_public_path__ + "img/eq-maiden-javelin.86e9436e.png";